// extracted by mini-css-extract-plugin
export default {"items":"ModelList__items___drO2O","item":"ModelList__item___QSdeB"};